import React, { useState } from "react";
import { Link } from "react-router-dom";
import p10 from '../../../assets/Images/career/c_5.JPG'
const jobsData = [
  {
    title: "PRODUCT DEVELOPMENT SCIENTIST",
    type: "Full-Time / On Site",
    category: "R&D",
  },
  {
    title: "DIGITAL MARKETING MANAGER",
    type: "Full-Time / On Site",
    category: "Marketing",
  },
  {
    title: "SUPPLY CHAIN COORDINATOR",
    type: "Full-Time / On Site",
    category: "Operations",
  },
];


const categories = ["All", "R&D", "Marketing", "Operations"];

const Fifth_CareerSection = () => {
  const [active, setActive] = useState("All");

  const filteredJobs =
    active === "All"
      ? jobsData
      : jobsData.filter((job) => job.category === active);

  return (
    <section className="bg-[#F2F6EF] py-12 md:py-16">

            {/* INLINE CSS */}
      <style>{`
          .gradient-text {
          background: linear-gradient(135deg, #355931 0%, #A4BE2C 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

          `}</style>
      <div className="max-w-7xl mx-auto px-4 sm:px-6">

        
          {/* Main Heading */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl text-center lg:text-4xl font-serif text-[#355931] leading-tight">
            Ready for Your <span className="gradient-text">Next Challenge? </span>
           
          </h2>
          {/* Underline */}
            <div
              className="
                w-24
                h-[2px]
                mx-auto
                mt-6
                mb-6
                dw-fade-up
              "
              style={{
                animationDelay: "240ms",
                background:
                  "linear-gradient(90deg, transparent 0%, #355931 30%, #A4BE2C 70%, transparent 100%)",
              }}
            />


        {/* Grid Layout - Responsive */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10 items-start">
          
          {/* Left Image - Responsive */}
          <div className="order-2 lg:order-1 ml-32">
           <div className="shine">
             <img
              src={p10}
              alt="Careers"
              className="w-full h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] object-cover rounded-lg shadow-md"
            />
           </div>
          </div>

          {/* Right Content - Responsive */}
          <div className="order-1 lg:order-2">
            
            {/* Filters - Responsive */}
            <div className="flex flex-wrap gap-2 sm:gap-3 mb-6 md:mb-8">
              {categories.map((cat, i) => (
                <button
                  key={i}
                  onClick={() => setActive(cat)}
                  className={`px-4 sm:px-5 py-1.5 sm:py-2 rounded-full border text-xs sm:text-sm font-medium transition duration-300 ${
                    active === cat
                      ? "bg-[#5A7B3E] text-white border-[#5A7B3E]"
                      : "text-[#2f4f2f] border-[#2f4f2f] hover:bg-[#2f4f2f] hover:text-white"
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>

            {/* Job List - Responsive */}
            <div className="space-y-4 sm:space-y-5 md:space-y-6">
              {filteredJobs.length > 0 ? (
                filteredJobs.map((job, index) => (
                  <div
                    key={index}
                    className="flex flex-col sm:flex-row sm:items-center sm:justify-between border-b border-gray-200 pb-4 sm:pb-5 gap-3"
                  >
                    
                    {/* Job Info */}
                    <div className="flex-1">
                      <h3 className="text-sm sm:text-base md:text-lg font-bold text-[#2f4f2f]">
                        {job.title}
                      </h3>
                      <p className="text-gray-600 text-xs sm:text-sm mt-1">
                        {job.type}
                      </p>
                    </div>

                    {/* Button */}
                  <Link to={'/apply-job-form'}>
                    <button className="cursor-pointer w-full sm:w-auto mt-2 sm:mt-0 bg-[#2f4f2f] text-white px-4 sm:px-6 py-2 rounded-md text-xs sm:text-sm hover:bg-[#244024] transition duration-300">
                      APPLY NOW
                    </button>
                  </Link>

                  </div>
                ))
              ) : (
                <div className="text-center py-8">
                  <p className="text-gray-500 text-sm sm:text-base">No jobs available in this category</p>
                </div>
              )}
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

export default Fifth_CareerSection;